<app-ph-input
  [validation]="'empty'"
  type="checkbox"
  name="filters_featured"
  [correctForm]="correctForm"
  (phInputChange)="onFeaturedChange()"
  [initValue]="featured"
>
  {{ 'PROJECTS.FILTERS.only_featured' | translate }}
</app-ph-input>
